import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ css, token, prefixCls }) => ({
  notice: css`
    &&.${prefixCls}-message-notice .${prefixCls}-message-notice-content {
      max-width: 640px;
      padding: 8px 12px;
      border-radius: ${token.borderRadius}px;
      box-shadow: none;
      text-align: start;
    }

    &&.${prefixCls}-message-notice-info
      .${prefixCls}-message-notice-content,
      &&.${prefixCls}-message-notice-loading
      .${prefixCls}-message-notice-content {
      background: ${token.colorInfoBg};
      border: 1px solid ${token.colorInfoBorder};
    }

    &&.${prefixCls}-message-notice-success
      .${prefixCls}-message-notice-content {
      background: ${token.colorSuccessBg};
      border: 1px solid ${token.colorSuccessBorder};
    }

    &&.${prefixCls}-message-notice-warning
      .${prefixCls}-message-notice-content {
      background: ${token.colorWarningBg};
      border: 1px solid ${token.colorWarningBorder};
    }

    &&.${prefixCls}-message-notice-error .${prefixCls}-message-notice-content {
      background: ${token.colorErrorBg};
      border: 1px solid ${token.colorErrorBorder};
    }

    &&.${prefixCls}-message-notice
      .${prefixCls}-message-notice-content
      .${prefixCls}-message-custom-content {
      align-items: flex-start;
      gap: 8px;
    }

    &&.${prefixCls}-message-notice .${prefixCls}-message-custom-content > span {
      flex: 1;
      min-width: 0;
    }
  `,

  small: css`
    &&.${prefixCls}-message-notice.${prefixCls}-message-notice
      .${prefixCls}-message-notice-content {
      padding: 4px 8px;
      border-radius: ${token.borderRadiusSM}px;
    }

    &&.${prefixCls}-message-notice.${prefixCls}-message-notice
      .${prefixCls}-message-custom-content {
      gap: 4px;
    }

    &.${prefixCls}-message-notice .${prefixCls}-message-custom-content > svg {
      font-size: 14px;
    }
  `,

  iconInfo: css`
    color: ${token.colorInfo};
    font-size: 16px;
    flex-shrink: 0;
  `,

  iconSuccess: css`
    color: ${token.colorSuccess};
    font-size: 16px;
    flex-shrink: 0;
  `,

  iconError: css`
    color: ${token.colorError};
    font-size: 16px;
    flex-shrink: 0;
  `,

  iconWarning: css`
    color: ${token.colorWarning};
    font-size: 16px;
    flex-shrink: 0;
  `,

  iconLoading: css`
    color: ${token.colorPrimary};
    font-size: 14px;
    flex-shrink: 0;
    animation: spin 1s linear infinite;

    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
  `,

  body: css`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    min-width: 0;
  `,

  bodySmall: css`
    && {
      gap: 4px;
    }
  `,

  text: css`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
  `,

  title: css`
    font-size: ${token.fontSize}px;
    line-height: 18px;
    font-weight: 600;
    color: ${token.colorText};
    word-break: break-word;
    hyphens: none;
  `,

  titleSmall: css`
    && {
      font-size: ${token.fontSizeSM}px;
      line-height: 16px;
    }
  `,

  description: css`
    font-size: ${token.fontSize}px;
    line-height: 18px;
    font-weight: 400;
    color: ${token.colorText};
    word-break: break-word;
    hyphens: none;
  `,

  descriptionSmall: css`
    && {
      font-size: ${token.fontSizeSM}px;
      line-height: 16px;
    }
  `,

  close: css`
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    flex-shrink: 0;
    margin: 0;
    padding: 0;
    border: none;
    background: transparent;
    font-size: 16px;
    line-height: 16px;
    color: ${token.colorTextDescription};
    cursor: pointer;

    &:hover {
      color: ${token.colorText};
    }

    &:focus-visible {
      outline: 2px solid ${token.colorPrimary};
      outline-offset: 2px;
      border-radius: 2px;
    }
  `
}))
